import {emotionStyled} from '@packages/utilities/styled';
import {HStack} from '../../Stack';

export const RowItemAdornmentView = emotionStyled(HStack)(
  {
    /**
     * We need to turn off pointer-events from the Adornment wrapper so that its padding and any Chevrons don't consume clicks.
     */
    pointerEvents: 'none',
  },
  {
    componentName: 'RowItemAdornment',
    variants: {
      isInteractive: {
        true: {
          pointerEvents: 'auto',
        },
      },
    },
  }
);
